<template>
  <div :style="bodyStyle" ref="scrollBody">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  props: {
    minheight: {
      type: Number,
      default: 200,
    },
    outheight: {
      type: Number,
      default: 120,
    },
    isScroll: {
      type: Boolean,
      default: true,
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    window.addEventListener("resize", this.resize);
    this.resize();
  },
  created() {

  },
  data() {
    return {
      //自适应窗口参数
      // bodyHeight: 0,
      bodyStyle: {
        overflowY: this.isScroll ? "auto" : "visible",
        overflowX: "hidden",
        height: "",
      },
    };
  },
  methods: {
    resize() {
      var bodyHeight = document.documentElement.clientHeight - this.outheight;
      var contentHeight = bodyHeight;
      if (this.isScroll == false) {
        var wrapper = this.$refs.scrollBody;
        if (wrapper) {
          var child = wrapper.children[0];
          if (child) {
            var childHeight = child.scrollHeight;
            // console.log('child:',childHeight,'bodyheight:',bodyHeight)
            if (childHeight > bodyHeight) {
              contentHeight = childHeight;
            }
          }
        }
      }

      this.bodyStyle.height = contentHeight + "px";
      this.$emit("resize",contentHeight)
    },
  },
};
</script>

<style lang="less" scoped>
</style>